define('home/views/common/FetchableCollectionLayout',[
    'underscore',
    'backbone-marionette',

    'home/views/common/FetchableCollectionView',
    'home/views/common/FetchableCollectionFooterView',
    'home/views/FetchingView',
    'home/views/UnreadCountView',

    'home/templates/fetchableCollectionLayout',
], function (
    _,
    Marionette,

    FetchableCollectionView,
    FetchableCollectionFooterView,
    FetchingView,
    UnreadCountView,

    fetchableCollectionLayoutTemplate
) {
    'use strict';

    /**
     * Can be used as is, by passing the fetchableCollectionView to the
     * constructor, or can be extended by a view that defines the
     * fetchableCollectionView. Either way may override the template,
     * so long as the expected content region and footer regions exist.
     *
     * Renders a given FetchableCollectionView along with a footer view.
     * Between the two of them they handle all the states for a collection
     * that is fetched initially and supports pagingation.
     *
     * The FetchableCollectionView handles initial collection fetching,
     * and empty collections.
     * The footer handles pagination, the fetch state during subsequent
     * fetches, errors, and when there are no more pages available.
     */
    var FetchableCollectionLayout = Marionette.Layout.extend({
        itemViewEventPrefix: 'collectionview',

        template: fetchableCollectionLayoutTemplate,
        regions: {
            headerRegion: '[data-role=header-area]',
            contentRegion: '[data-role=content-area]',
            footerRegion: '[data-role=footer-area]',
        },

        fetchableCollectionFooterView: FetchableCollectionFooterView,

        initialize: function (options) {
            if (options.fetchableCollectionView)
                this.fetchableCollectionView = options.fetchableCollectionView;

            if (!this.fetchableCollectionView ||
                !(this.fetchableCollectionView === FetchableCollectionView ||
                  this.fetchableCollectionView.prototype instanceof FetchableCollectionView))
                throw new Error('A FetchableCollectionLayout must define a fetchableCollectionView');

            if (options.fetchableCollectionFooterView)
                this.fetchableCollectionFooterView = options.fetchableCollectionFooterView;

            if (!this.contentRegion || !this.footerRegion)
                throw new Error('A template for a FetchableCollectionLayout must define a content region and a footer region');

            this.listenTo(this.collection, 'unreadItemsReady', this.updateHeader);

            this.options = options;
        },

        updateHeader: function () {
            var unreadCountView = new UnreadCountView({
                collection: this.collection,
            });

            this.headerRegion.show(unreadCountView);
        },

        onDomRefresh: function () {
            /* eslint-disable new-cap */
            if (this.contentRegion.currentView)
                this.stopListening(this.contentRegion.currentView);

            var view = new this.fetchableCollectionView(_.clone(this.options));
            var collection = view.collection;

            // Kick off a sequence of events for timeline collections that
            // results in the collection fetching unread items, if any exist. When
            // it is done fetching new items, it will fire 'unreadItemsReady'.
            if (collection.updateUnreadCount)
                collection.updateUnreadCount();

            if (view.listenable.ensureFetched)
                view.listenable.ensureFetched();

            Marionette.CollectionView.prototype.addChildViewEventForwarding.call(this, view);

            this.contentRegion.show(new FetchingView());
            _.defer(_.bind(function () {
                // This view may have been closed since defer was scheduled (ex: by
                // the parent view rerendering). If that is the case, unable to
                // update content.
                if (this.isClosed)
                    return;

                this.contentRegion.show(view);
                this.trigger('showCollection', view);

                this.footerRegion.show(new this.fetchableCollectionFooterView({
                    model: this.model,
                    collection: this.collection,
                }));
            }, this));
            /* eslint-enable new-cap */
        },

        // Called by addChildViewEventForwarding
        getItemEvents: Marionette.CollectionView.prototype.getItemEvents,
    });

    return FetchableCollectionLayout;
});

